import { CHART_TYPES } from "../charts/constants";

export const REPORT_ON_KEY = 'tasks';
export const INCLUDE_FROM_PORTFOLIOS = 'portfolios';
export const INCLUDE_FROM_PROJECTS = 'projects';

export const GROUP_OPTIONS = {
  ASSIGNEE: 'assignee',
  BURN_REPORT: 'burnReport',
  CREATOR: 'creator',
  CUSTOM_FIELD: 'custom-field',
  CUSTOM_FIELD_PREFIX: 'customFields.',
  TAG: 'tag',
  COMPLETION: 'completion',
  PRIORITY: 'priority',
  PROJECT: 'project',
};

export const INTERVAL_OPTIONS = {
  DAY: 'day',
  WEEK: 'week',
  MONTH: 'month',
  QUARTER: 'quarter',
  YEAR: 'year',
};

export const RANGE_TYPE_OPTIONS = {
  LAST: 'last',
  BETWEEN: 'between',
};

export const TIME_UNIT_OPTIONS = {
  DAYS: 'days',
  WEEKS: 'weeks',
  MONTHS: 'months',
};

export const EXCLUDED_CHART_TYPES_FOR_X_AXIS = [
  CHART_TYPES.NUMBER,
  CHART_TYPES.PIE,
  CHART_TYPES.BURNUP,
  CHART_TYPES.BURNDOWN,
];
